'use strict';

module.exports = function(Chart) {

	Chart.Bar = function(context, config) {
		config.type = 'bar';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// ../~/chart.js/src/charts/Chart.Bar.js
// module id = 464
// module chunks = 0